import type { AbsolutePath } from "shelving";
import { Icon, PathButton } from "shared/react";

export function CreatorMenu({ path, verified = false }: { path: AbsolutePath; verified?: boolean }): React.ReactElement {
	return (
		<nav className="flex-column gap-hairline">
			<h2 className="label">Created</h2>
			<div className="grid gap-hairline">
				<PathButton path={`${path}/challenges`}>
					<Icon icon="challenge" /> <span>Challenges</span>
				</PathButton>
				<PathButton path={`${path}/badges`}>
					<Icon icon="badge" /> <span>Badges</span>
				</PathButton>
				<PathButton path={`${path}/backgrounds`}>
					<Icon icon="background" /> <span>Backgrounds</span>
				</PathButton>
				{verified ? (
					<PathButton path={`${path}/reactions`}>
						<Icon icon="reaction" /> <span>Reactions</span>
					</PathButton>
				) : null}
				<PathButton path={`${path}/lists`}>
					<Icon icon="list" /> <span>Lists</span>
				</PathButton>
				<PathButton path={`${path}/notes`}>
					<Icon icon="note" /> <span>Notes</span>
				</PathButton>
			</div>
		</nav>
	);
}
